import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReply = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 140,
	height: 140,
	viewBox: "0 0 140 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M39.1808 32.1472C39.508 31.491 38.8587 30.7859 38.1847 31.0612L23.3302 36.6992C22.975 36.8442 22.6902 37.1098 22.5194 37.4462L0.337854 81.4703C0.134585 81.8732 0.0201956 82.3154 0.00244038 82.767C-0.0153148 83.2185 0.063979 83.6689 0.234939 84.0875C0.405905 84.5061 0.664554 84.8831 0.993351 85.1932C1.32215 85.5032 1.71342 85.7389 2.14065 85.8843L49.0749 101.893C49.26 101.956 49.4501 101.953 49.6232 101.882L64.7509 96.1329C65.4249 95.8576 65.3912 94.8904 64.702 94.66L26.7389 81.7141L26.9178 81.657C64.2253 57.6206 112.56 69.7187 126.101 108.433C126.416 109.336 127.391 109.85 128.302 109.561L138.804 106.22C139.715 105.931 140.218 104.948 139.909 104.043C124.024 57.5817 69.8291 37.8002 22.5282 67.8551C22.0944 67.9931 21.6623 68.134 21.232 68.2779L39.1808 32.1472Z",
		fill: "#26292E"
	})
});
export default SvgReply;
